import { inject } from '@angular/core';
import { type CanActivateFn, Router, UrlTree } from '@angular/router';
import { Core } from "@core/core";

export const authGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
    const core = inject(Core);
    const router: Router = inject(Router);
    const auth = await core.session.check();

    if (!auth) {
        return router.createUrlTree(['/']);
    }

    return true;
};
